<template>
  <!-- Indices -->
  <div class="w3-container w3-small" id="indices">
    <div class="w3-hide-large" style="margin-top:80px"></div>
    <h1 class="w3-xxlarge w3-text-black">
      <b>Indices.</b>
    </h1>
    <hr style="width:50px;border:5px solid black" class="w3-round" />
    <div>
      <datepicker
        class="w3-margin w3-left w3-padding-small"
        placeholder="yyyy-MM-dd"
        :typeable="true"
        format="yyyy-MM-dd"
        v-model="indexdate"
      ></datepicker>
      <button
        class="w3-left w3-button w3-black w3-margin"
        @click="getIndices()"
      >
        <i class="fa fa-search"></i>&nbsp;Search
      </button>
      <ExportToExcel
        @if="indices"
        :FieldNames="indicesFields"
        :FileName="'Indices_' + indexdate"
        :InputData="indices"
      />
    </div>
    <div class="w3-clear">
      <div class="w3-responsive">
        <table class="w3-table-all">
          <caption @if="indices" style="text-align:left; font-size:medium">
            Indices for
            {{
              indexdate | formatDate("YYYY-MM-DD")
            }}
          </caption>
          <thead class="w3-gray">
            <!-- <th class="nowrap">Date</th> -->
            <th class="nowrap">Indices</th>
            <th class="w3-right-align nowrap">Turnover</th>
            <th class="w3-right-align nowrap">Current</th>
            <th class="w3-right-align nowrap">Point Change</th>
            <th class="w3-right-align nowrap">% Change</th>
          </thead>
          <tbody>
            <tr v-show="indicesloading">
              <td colspan="6">Loading...</td>
            </tr>
            <tr v-show="indicesmessage">
              <td colspan="6">{{ indicesmessage }}</td>
            </tr>
            <tr
              v-show="!indicesloading"
              v-for="indice in indices"
              v-bind:key="indice.indexName"
            >
              <!-- <td class="w3-left-align nowrap">{{ indice.tradedate }}</td> -->
              <td class="w3-left-align nowrap">{{ indice.indexName }}</td>
              <td class="w3-right-align nowrap">
                {{ Number(indice.turnover).toLocaleString() }}
              </td>
              <td class="w3-right-align nowrap">
                {{ Number(indice.indexValue).toLocaleString() }}
              </td>
              <td class="w3-right-align nowrap">{{ indice.absoluteChange }}</td>
              <td class="w3-right-align nowrap">{{ indice.percentChange }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import DataService from "@/services/DataService";
import ExportToExcel from "@/components/ExportToExcel";
export default {
  name: "Indices",
  components: {
    Datepicker,
    ExportToExcel,
  },
  data() {
    return {
      indices: [],
      indexdate: "",
      indicesloading: false,
      indicesmessage: "",
      indicesFields: [
        "Date",
        "Indices",
        "Symbol",
        "Turnover",
        "Current",
        "Point Change",
        "% Change",
      ],
    };
  },
  methods: {
    async getIndices() {
      this.indicesloading = true;
      this.indicesmessage = "";
      const response = await DataService.getIndicesFromApi(this.indexdate);
      if (response.data) {
        this.indices = response.data;
        if (this.indices.length > 0) {
          this.indexdate = this.indices[0].tradedate
            .toString()
            .replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
          this.indicesmessage = "";
        } else {
          this.indicesmessage = "No Data Found";
        }
      }
      this.indicesloading = false;
    },
  },
  created() {
    this.getIndices();
  },
};
</script>

<style></style>
